<script>
export default {
	name: 'MHVideo',
	inheritAttrs: false,
};
</script>

<script setup>
import BaseVideo from '~/components/BaseVideo.vue';

const props = defineProps({
	videoSrc: { type: String, default: 'aem' }, // <== 'aem' || 'youtube'
	caption: { type: String, default: '' },
	captionAlignment: { type: String, default: 'left' }, // <== 'left' || 'center' || 'right'
	altText: { type: String, default: '' },
	videoPath: { type: String, default: '' },
	thumbnailImg: { type: String, default: '' },
	thumbnailAltText: { type: String, default: '' },
	youtubeId: { type: String, default: '' }, // <== e.g. '1ASB22OMeZg'
	componentIdAA: { type: String, default: '' },
});
const captionAlignmentMap = {
	left: 'text-left',
	center: 'text-center',
	right: 'text-right',
};

</script>


<template>
<div class="MHVideo">
	<BaseVideo
		:type="props.videoSrc"
		:src="props.videoSrc === 'aem' ? props.videoPath : props.youtubeId"
		:poster="props.videoSrc === 'aem' && props.thumbnailImg ? props.thumbnailImg : ''"
		:thumbnailAltText="props.thumbnailImg && props.thumbnailAltText ? props.thumbnailAltText : ''"
		:videoAltText="props.altText"
		:componentIdAA="props.componentIdAA"
	/>

	<p
		v-if="props.caption"
		class="text-sm text-neutral-grey-ultradark my-3"
		:class="captionAlignmentMap[props.captionAlignment]"
	>{{ props.caption }}</p>
</div>
</template>



<style lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';
.MHVideo {
	.vjs-big-play-button {
		margin-left: 0;
		transform: translateX(-50%);
	}

	.vjs-poster {
		background-size: cover;
	}
}
</style>
